// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1friN","Success":"Button_Success__216Xq","Danger":"Button_Danger__1t7Lx"};